import script from "./installed-terminal-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./installed-terminal-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./installed-terminal-drawer.vue?vue&type=style&index=0&id=e62385a4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e62385a4"]])

export default __exports__